import { ApiDatafanSmpAccounts } from "./accounts";
import { ApiDatafanSmpProviders } from "./providers";
export class ApiDatafanSmp {
}
ApiDatafanSmp.Accounts = ApiDatafanSmpAccounts;
ApiDatafanSmp.Providers = ApiDatafanSmpProviders;
//# sourceMappingURL=smp.js.map